

(function (module) {
    "use strict";

    module.service('vmiDataProvider', ['$http', function(this: $TSFixMe, $http: ng.IHttpService) {
        var service = this;

        service.getRotationInfo = function (forecastStartDate: $TSFixMe, oracleIndexes: $TSFixMe) {
            return $http(
                {
                    method: 'GET',
                    url: 'api/vmi/rotationInfo',
                    params: {
                        oracleIndexes, forecastStartDate
                    }
                }).then((response: $TSFixMe) => {
                    var dict = {};
                    for (const vmiData of response.data) {
                        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                        dict[vmiData.oracleIndex] = vmiData.vmi;
                    }
                    return dict;
                });
        }
    }]);


})(angular.module('topline.modules'));